import { Box, CircularProgress, Grid, Switch, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import Select_DSAS from "../Select_Dsas.js";
import CreatePlayerModal from "./CreatePlayerModal.js";
import PositionResolver from "./PositionResolver.js";
import useStyles from '../../styles/global-mui.js'
import { CustoFlatSelect } from "./CustoSelectFeuilleMatch.js";
import { useFeuilleDeMatch } from "./useFeuilleDeMatch.js";
import DsasButton from "../../v1/components/DsasButton/DsasButton.js";
import { faTrashCan, faUserPlus } from "@fortawesome/free-solid-svg-icons";

const SoccerFeuilleMatch = ({match, matchData, setMatchData, isHome, isPopup = false, compositionsList}) => {

    const classes = useStyles();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const [editing, setEditing] = useState(false);

    let holdersLabel = isHome ? 'homeHolders' : 'awayHolders'
    let susbstitutesLabel = isHome ? 'homeSubstitutes' : 'awaySubstitutes'
    let teamIdLabel = isHome ? 'homeTeam' : 'awayTeam'
    let teamCompositionLabel = isHome ? 'homeComposition' : 'awayComposition'
    let teamCoachLabel = isHome ? 'homeCoach' : 'awayCoach'

    const {[teamIdLabel] : teamId} = matchData

    let team = match[teamIdLabel]

    const safeTeam = team || { players: [] };
    const teamPlayers = safeTeam.players.sort((a,b) => a.lastname.localeCompare(b.lastname));

    // Charger les listes de joueurs
    // let teamPlayers = team.players.sort((a, b) => a.lastname.localeCompare(b.lastname))

    const {handleSelectPlayer, handleSelectSub, displayCoachGamefact} = useFeuilleDeMatch({
        discipline : match.discipline, 
        match,
        matchData, 
        holdersLabel, 
        susbstitutesLabel, 
        setMatchData, 
        teamPlayers
    })

    const width = isSmall ? 350 : 500
    const height = 1.448 * width

    const handleSelectComposition = (e) => {
        //numéros de position par défaut pour les holders si pas d'_id, on fait h.numero = h.position+1
        const holders = matchData[holdersLabel];
        holders.forEach(h => {
            if(!h._id) {
                h.numero = h.position + 1;
            }}
        )
        setMatchData(s => ({...s, [holdersLabel] : holders , [teamCompositionLabel] : e.target.value}))
    }

    const handleSelectCaptain = useCallback((value) => {
        const holders = matchData[holdersLabel].map(h => {
            if(h._id === value)
                return {...h, isCpt : true}

            return {...h, isCpt : false}
        })

        setMatchData(s => ({...s, [holdersLabel] : holders}))
    }, [matchData[holdersLabel]])

    const getSelectedCaptain = useMemo(() => {
        const holders = matchData[holdersLabel]

        const captainHolder = holders.find(h => h.isCpt)

        if(captainHolder)
            return captainHolder._id
    }, [holdersLabel, matchData])

    const getPlayerCaptainList = useCallback(() => {
        const holders = matchData[holdersLabel]

        const playerCaptainList = holders.map(h => {
            return teamPlayers.find(p=> p._id === h._id)
        })

        return playerCaptainList
    }, [holdersLabel, matchData, teamPlayers])


    const handleChangePlayerNumber = useCallback((value, idx) => {
        let newHolders = matchData[holdersLabel].map(h => {
            if(h.position === idx)
                return {...h, numero : value}
            return h
        })

        setMatchData(s => ({...s, [holdersLabel] : newHolders}))
    }, [holdersLabel, matchData])

    const handleChangeSubNumber = useCallback((value, idx) => {
        let newSubs = matchData[susbstitutesLabel].map(h => {
            if(h.position === idx)
                return {...h, numero : value}
            return h
        })

        setMatchData(s => ({...s, [susbstitutesLabel] : newSubs}))
    }, [susbstitutesLabel, matchData])

    

    // const handleAddSub = () => {
    //     let newSubs = matchData[susbstitutesLabel]
    //     newSubs.push({})
    //     setMatchData(s => ({...s, [susbstitutesLabel] : newSubs}))
    // }

    const handleAddSub = () => {
            let newSubs = matchData[susbstitutesLabel]
            //get most high position from newSubs if newSubs is not empty. Otherwise, set to 1.
            let nextPosition = newSubs.length > 0 ? Math.max(...newSubs.map(s => s.position&&s.position>0 ? s.position+1 : newSubs.length)) : 0
            newSubs.push({position : nextPosition, numero : nextPosition+12})
            setMatchData(s => ({...s, [susbstitutesLabel] : newSubs}))
        }

     const handleDeleteSub = (sub) => {
        let newSubs = matchData[susbstitutesLabel]
        newSubs = newSubs.filter(s => s._id ? (s._id!==sub._id) : (s.position !== sub.position ))
        setMatchData(s => ({...s, [susbstitutesLabel] : newSubs}))
    }


    const isPlayerNumberValued = useCallback(() => {
        let nbPlayersWithNumber = teamPlayers.reduce((acc, p) => {
            if(p.number)
                acc++
            
            return acc
        }, 0)

        //20% des joueurs ont un numero ?
        return nbPlayersWithNumber >= (teamPlayers.length*20/100)
    }, [teamPlayers])

    const getPlayerName = useCallback((idx) => {
        let dataPlayer = getPlayerInHolders(idx)
        let player = teamPlayers.find(p=> dataPlayer && p._id === dataPlayer._id)

        if(!player)
            return 'player'
        else
            return player.lastname

    }, [matchData[holdersLabel], teamPlayers])

    const getPlayerInHolders = useCallback((idx) => {
        let playerInData = matchData[holdersLabel].find(d => d && d.position === idx)

        return playerInData
    }, [holdersLabel, matchData])


    const getSubNumero = (sub, idx) => {
        if(matchData[teamCompositionLabel] === '__default__')
            return idx+12
        
        
        return sub.numero ?? idx+12
    }

    if(!team)
        return <CircularProgress/>

    return <Grid container sx={{flexDirection : 'row', textAlign : 'center', justifyContent : 'center'}}>
            <Grid item xs={12}>
                <Typography variant='body1' sx={{fontSize : '1.5em'}} >{team.name}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Box className='padding-wrapper'>
                    <CreatePlayerModal teamId={teamId} discipline={'soccer'} provider={matchData.provider} match={match}/>
                </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6}>
                
                <Box className='medium-padding'>
                    <Box sx={{display:'flex'}}>
                        <Typography variant='h2' sx={{textTransform:'uppercase'}}>Configuration générale</Typography>
                    </Box>
                    
                    {compositionsList && <Box className='small-padding'>
                        <Select_DSAS 
                            className={classes.customInput}
                            fullWidth
                            label="composition" 
                            items={compositionsList} 
                            onChange={handleSelectComposition} 
                            value={matchData[teamCompositionLabel]} 
                        /></Box>}
                    
                        <Box className='centered-wrapper small-padding'>
                            <TextField 
                            className={classes.customInput} 
                            fullWidth
                            label="Entraîneur" 
                            onChange={(e) => setMatchData(s => ({...s, [teamCoachLabel] : e.target.value}))} 
                            value={matchData[teamCoachLabel]}></TextField>
                            <Typography className={classes.customInputLabel}>{displayCoachGamefact(matchData[teamIdLabel])}</Typography>
                        </Box>
                        
                        <Box className='small-padding'>
                            <Select_DSAS 
                            className={classes.customInput}
                            fullWidth
                            label="Capitaine" 
                            items={getPlayerCaptainList()} 
                            onChange={(e) => handleSelectCaptain(e.target.value)} 
                            value={getSelectedCaptain} />
                        </Box>

                </Box>

                { (!matchData[teamCompositionLabel] || matchData[teamCompositionLabel] === '__default__') ?
                        <Box className='medium-padding'>
                           <Box sx={{display:'flex'}}>
                                <Typography variant='h2' sx={{textTransform:'uppercase'}}>Titulaires</Typography>
                            </Box>
                        {[1,2,3,4,5,6,7,8,9,10,11].map((holder, idx) => 
                            <Grid container justifyContent={'center'} key={idx}>
                                <Grid xs item>
                                    <Box className='small-padding'>
                                    <CustoFlatSelect 
                                                inexistantList={teamPlayers.filter(p => 
                                                    matchData[holdersLabel].every(d => d._id !== p._id) && matchData[susbstitutesLabel].every(s => s._id !== p._id))
                                                                .sort((a,b) => a.lastname.localeCompare(b.lastname))} 
                                                existantList={teamPlayers.filter(p => 
                                                    matchData[holdersLabel].find(d => d._id === p._id) || matchData[susbstitutesLabel].find(s => s._id === p._id))
                                                                .sort((a,b) => a.lastname.localeCompare(b.lastname))} 
                                                onSelect={(value) => handleSelectPlayer(value, idx)} 
                                                getPlayerInHolders={getPlayerInHolders}
                                                name={"homeholder"}
                                                value = {getPlayerInHolders(idx) ? getPlayerInHolders(idx)._id : ''}
                                                label = {idx===0 ? "Gardien "+(idx+1) : "Titulaire "+(idx+1)}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        )}</Box> :
                    <Box sx={{mt:1}}>
                        <Box sx={{display:'flex'}} className='medium-padding-left'>
                                <Typography variant='h2' sx={{textTransform:'uppercase'}}>Titulaires</Typography>
                            </Box>
                        <EditToggle editing={editing} setEditing={setEditing}/>
                        <Box className={'terrain_feuillematch_holders'} width={width} height={height} sx={{position : 'relative', display : 'block', left: '50%', 
                        transform : 'translateX(-50%)'}}>
                                <PositionResolver editing={editing} fullWidth={width} fullHeight={height} players={teamPlayers} onSelect={handleSelectPlayer} onChangeNumber={handleChangePlayerNumber} composition={matchData[teamCompositionLabel]} data={matchData[holdersLabel]} subs={matchData[susbstitutesLabel]} isSmall={isSmall} isPlayerNumberValued={isPlayerNumberValued()}/>
                        </Box>
                    </Box>
                }
                
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6}>
                <Box className='medium-padding'>
                    <Box sx={{display:'flex'}}>
                        <Typography variant='h2' sx={{textTransform:'uppercase'}}>Remplaçants</Typography>
                    </Box>
                
                    {matchData[susbstitutesLabel] && matchData[susbstitutesLabel].map((sub, idx) => 
                        <Grid container key={idx} sx={{alignItems: 'center'}}>
                            <Grid xs item>
                                <Box className='small-padding'>
                                    <CustoFlatSelect 
                                            inexistantList={teamPlayers.filter(p => 
                                                matchData[holdersLabel].every(d => d._id !== p._id) && matchData[susbstitutesLabel].every(s => s._id !== p._id))
                                                            .sort((a,b) => a.lastname.localeCompare(b.lastname))} 
                                            existantList={teamPlayers.filter(p => 
                                                matchData[holdersLabel].find(d => d._id === p._id) || matchData[susbstitutesLabel].find(s => s._id === p._id))
                                                            .sort((a,b) => a.lastname.localeCompare(b.lastname))} 
                                            onSelect={(value) => handleSelectSub(value, idx)} 
                                            name={"homeSubstitutes"}
                                            label={"Remplaçant "+(getSubNumero(sub, idx))}
                                            value={sub._id ?? ""}
                                            editing={editing}
                                            editingValue={getSubNumero(sub, idx)}
                                            onChangeEditing={(value) => handleChangeSubNumber(value, idx)}
                                        />
                                </Box>
                            </Grid>
                            <Grid xs={2} item>
                                <DsasButton 
                                onClick={() => handleDeleteSub(sub)} 
                                variant="secondary" 
                                icon={faTrashCan} 
                                label=''
                                customCss={{
                                    width: '3rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '8px'
                                }}
                                customClassname={'svg-no-padding'}
                                ></DsasButton>
                            </Grid>
                        </Grid>
                    )}
                    <Box className='centered-wrapper small-padding'>
                        <DsasButton onClick={handleAddSub} variant="secondary" icon={faUserPlus} label='Ajouter un remplaçant'></DsasButton>
                    </Box>
                </Box>
            </Grid>
    </Grid>
    
}

const EditToggle = ({editing, setEditing}) => {

    const handleToggle = () => {
      setEditing(!editing);
    };
  
    return (
      <Box 
      className='padding-wrapper'
      sx={{ display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'}}>
        <Typography className='' variant="body1" style={{ paddingLeft:'10px', marginRight: 10 }}>
          Editer les numéros
        </Typography>
        <Switch
          checked={editing}
          onChange={handleToggle}
          color="primary"
          name="edit-toggle"
          inputProps={{ 'aria-label': 'editer-toggle' }}
        />
      </Box>
    );
  };
export default SoccerFeuilleMatch